import {
  createUser,
  forgotPassword,
  getUser,
  issueUnifiedLoginTicket,
  redeemUnifiedLoginTicket,
  requestRegistration,
  validateToken,
} from "@ckweb/ckfetch/connectables/plantApi";

export function useRequestConfirmationEmail() {
  return useSafeLocalFetch("requestConfirmationEmail", requestRegistration, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}

export function useValidateConfirmationEmailToken() {
  return useSafeLocalFetch("validateConfirmationEmailToken", validateToken, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}

export function useCreateUser() {
  return useSafeLocalFetch("createUser", createUser, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}

export function useForgotPassword() {
  return useSafeLocalFetch("forgotPassword", forgotPassword, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    mapError: "auth.forgotUsernameOrPasswordErrorMessage",
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}

export function useGetUser() {
  return useSafeLocalFetch("getUser", getUser, {
    showGlobalLoadingIndicator: true,
  });
}

export function useIssueAuthTicket() {
  return useSafeLocalFetch("issueUnifiedLoginTicket", issueUnifiedLoginTicket, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: false,
  });
}

export function useRedeemAuthTicket() {
  return useSafeLocalFetch("redeemUnifiedLoginTicket", redeemUnifiedLoginTicket, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: false,
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}
